import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {addToWizard} from '../../store/actions';
import {createClassName} from '../../util/utility';
import {Column} from '../layout';
import StepperHeader from './stepper-header';

import './styles.scss';

export interface Step {
  index: number;
  label: string;
  component(onSubmit: any, nextStepHandler: any): any;
  onSubmit(values: any): void;
}

export interface StepperProps {
  step: number;
  steps: Step[];
  className: string;
  wizard: any;
  addToWizard(value: any): void;
  currentStepValid?: boolean;
}

export interface StepperState {}

class Stepper extends React.Component<StepperProps, StepperState> {
  state = {
    step: this.props.wizard.step || 0,
    steps: this.props.steps || [],
    formValues: {},
  };

  setFormValues = (values: any) => this.setState({formValues: values});

  nextStep = () => {
    const {steps} = this.state;
    const {addToWizard, wizard} = this.props;
    const step = wizard.step || 0;
    const nextStep = step < steps.length - 1 ? step + 1 : step;
    this.setState({step: nextStep});
    addToWizard({step: nextStep});
  };

  render() {
    const {steps, className, wizard} = this.props;
    const {step} = this.state;

    const classes = createClassName('stepper-main-column', className);

    return (
      <Column className={classes}>
        <StepperHeader currentStep={wizard.step || 0} steps={steps} />
        <div className="stepper-content">
          {steps[wizard.step || 0].component(
            steps[step].onSubmit,
            this.nextStep
          )}
        </div>
      </Column>
    );
  }
}

const mapStateToProps = ({wizard}: any) => ({
  wizard: wizard.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(Stepper));
